module.exports = __webpack_public_path__ + "static/media/docker.11c8d37b.png";